/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-delivery-fees';

export const EntityDeliveryFeesApi = {
  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: EntityDeliveryFeeQuery) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findDistanceDeliveryFee: async (body: any) => {
    const url = `${pathname}/distance-shipping-fee`;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface EntityDeliveryFeeQuery {
  ownerID?: number;
  order?: any;
  page?: number;
  take?: number;
  skip?: number;
  tab?: string;
  reserved?: boolean;
}
